"use client"
import { GA_MEASUREMENT_ID, MOCK_ALL_APIS } from "@/constants"
import { Component } from "@/types/types"
import Script from "next/script"

export const presets = {}

export interface Props extends Component {
  gaMeasurementId: string
}

export function GoogleAnalyticsLoader({ gaMeasurementId }: Props) {
  if (MOCK_ALL_APIS) return null

  return (
    <>
      <Script
        id="gtag"
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`}
        strategy="beforeInteractive"
      />
      <Script id="ga" strategy="beforeInteractive">
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaMeasurementId}', { send_page_view: false });
      `}
      </Script>
    </>
  )
}
